import moment from 'moment';

/**
 * Gets the difference between a date & the start of the current day
 */
export function getDateDiff(date: Date, unitOfTime: moment.unitOfTime.Diff = 'd'): { diff: number; sign: '+' | '-' } {
  const diff = moment().startOf('day').diff(moment(date), unitOfTime);
  const sign = diff > 0 ? '+' : '-';
  return { diff, sign };
}

export function isDateExpired(date: number): boolean {
  return date < Date.now();
}

export function isBackendDateExpired(date: number): boolean {
  return isDateExpired(convertBackendDateToJSDate(date));
}

/**
 * Converts a backend timestamp (number of seconds elapsed since the epoch) to a js timestamp  (number of milliseconds elapsed since the epoch).
 * @param date backend timestamp
 * @returns A number representing the timestamp, in milliseconds, of the current time.
 */
export function convertBackendDateToJSDate(date: number): number {
  return date * 1000;
}
